import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock, Linkedin, Instagram, Facebook } from 'lucide-react';
import { companyInfo } from '../../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-6">
            <Link to="/" className="inline-block">
              <img
                src="https://customer-assets.emergentagent.com/job_mk-locales/artifacts/hewtwgia_WhatsApp_Image_2026-02-10_at_10.02.57-removebg-preview%20%281%29.png"
                alt="Corporativo MK"
                className="h-20 w-auto"
              />
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed">
              {companyInfo.description}
            </p>
            <div className="flex space-x-4">
              <a
                href={companyInfo.social.linkedin}
                className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-sky-500 hover:text-white transition-all duration-200"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href={companyInfo.social.instagram}
                className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-sky-500 hover:text-white transition-all duration-200"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href={companyInfo.social.facebook}
                className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-sky-500 hover:text-white transition-all duration-200"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Enlaces Rápidos</h3>
            <ul className="space-y-3">
              {[
                { path: '/', label: 'Inicio' },
                { path: '/acerca', label: 'Acerca de' },
                { path: '/servicios', label: 'Servicios' },
                { path: '/locales', label: 'Locales Disponibles' },
                { path: '/contacto', label: 'Contacto' },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-slate-400 hover:text-sky-400 transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Nuestros Servicios</h3>
            <ul className="space-y-3">
              {[
                'Oficinas Privadas',
                'Coworking',
                'Salas de Juntas',
                'Oficinas Virtuales',
                'Eventos Corporativos',
              ].map((service) => (
                <li key={service}>
                  <Link
                    to="/servicios"
                    className="text-slate-400 hover:text-sky-400 transition-colors text-sm"
                  >
                    {service}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Contacto</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-sky-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-400 text-sm">{companyInfo.address}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-sky-400 flex-shrink-0" />
                <a
                  href={`tel:${companyInfo.phone}`}
                  className="text-slate-400 hover:text-sky-400 transition-colors text-sm"
                >
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-sky-400 flex-shrink-0" />
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="text-slate-400 hover:text-sky-400 transition-colors text-sm"
                >
                  {companyInfo.email}
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Clock className="w-5 h-5 text-sky-400 flex-shrink-0" />
                <span className="text-slate-400 text-sm">{companyInfo.hours}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-slate-400 text-sm">
              © {currentYear} Corporativo MK. Todos los derechos reservados.
            </p>
            <div className="flex space-x-6">
              <a href="#" className="text-slate-400 hover:text-sky-400 transition-colors text-sm">
                Política de Privacidad
              </a>
              <a href="#" className="text-slate-400 hover:text-sky-400 transition-colors text-sm">
                Términos y Condiciones
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
